<template>
  <div id="home">
    <div class="top">
      <div class="top-item">
        <div class="title">岗位职级</div>
        <div class="name">
          <span class="big">{{ employJobInfo.jobName }}</span>
          <span class="sub-lv"> {{ employJobInfo.jobCode }}</span>
        </div>
        <div class="name-bot-wrapper">
          <div class="next-lv">
            下一级：{{ employJobInfo.nextJobName }}{{ employJobInfo.nextJobCode }}
          </div>
        </div>
        <div class="bot">
          <span class="lv-percent">{{ employJobInfo.percentage }}</span>
          的人达到此级别
        </div>
      </div>
      <div class="top-item">
        <div class="title">本月积分</div>
        <div class="name">
          <span class="big">{{ monthScore.thisMonthScore }}</span>
          <span class="sub-lv"></span>
        </div>
        <div class="name-bot-wrapper">
          <div class="next-lv">
            <span>月环比</span>
            <span class="count">{{ monthScore.monthRatio }}</span>
          </div>
          <div class="next-lv">
            <span>累计积分</span>
            <span class="count">{{ monthScore.accumulateScore }}</span>
          </div>
        </div>
        <div class="bot">
          <span class="lv-percent">{{ monthScore.monthScorePercent }}</span>
          的员工达到本月所得积分数量
        </div>
      </div>
      <div class="top-item">
        <div class="title">积分兑换</div>
        <div class="name">
          <!-- <span class="big">高级架构师</span>
          <span class="sub-lv">Lv T4-3</span> -->
          <span class="big">
            1 积分 = 10 人民币
          </span>
        </div>
        <div class="name-bot-wrapper">
          <div class="next-lv" style="height:14px">
            <!-- <span>累计积分</span>
            <span class="count">200000</span> -->
          </div>
          <div class="next-lv" style="height:14px">
            <!-- <span>累计积分</span>
            <span class="count">200000</span> -->
          </div>
        </div>
        <div class="bot">
          <span style="color:red" class="lv-percent">+0.2%</span><i style="color:red" class="el-icon-caret-top">涨幅</i>
        </div>
      </div>
    </div>
    <div class="bot-container">
      <div class="count-wall">
        <div class="title">
          <span>积分墙</span>
          <span class="jf-rule">积分规则</span>
        </div>
        <div class="count-wall-lists">
          <template v-if="completedTask.length>0">
            <div class="item" v-for="item in completedTask">
              <div class="tag-wra">
                <el-tag type="success" size="mini">奖励</el-tag>
                <el-tag type="success" size="mini">{{ taskStatusEumLists[item.taskStatus] }}</el-tag>
              </div>
              <div class="name">
                {{ item.taskName }}
              </div>
              <div class="user-name">{{ item.employName }}</div>
              <div class="time-data">
                {{ item.createTime }}
              </div>
            </div>
          </template>
          <template v-else>
            <el-empty description="暂无数据"></el-empty>
          </template>
        </div>
      </div>
      <div class="task-wrap">
        <div class="task-top">
          <div class="title">最近任务</div>
          <div class="more">更多>></div>
        </div>
        <div class="task-list">
          <template v-if="latestTaskList.length>0">
            <div class="item" v-for="item in latestTaskList">
              <div class="tag-wra">
                <el-tag size="mini">{{ pickTypeLists[item.pickType] }}</el-tag>
                <el-tag :type="statusType(item.taskStatus)" size="mini">{{ taskStatusEumLists[item.taskStatus] }}</el-tag>
              </div>
              <div class="name">
                {{ item.taskName }}
              </div>
              <div class="time-data">
                {{ item.createTime }}
              </div>
            </div>
          </template>
          <template v-else>
            <el-empty description="暂无数据"></el-empty>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, getCurrentInstance, onMounted, ref, inject } from '@vue/composition-api'
export default {
  name: 'Home',
  props: [

  ],
  setup (props, ctx) {
    const vm = getCurrentInstance()
    console.log(vm.proxy.$service)
    // vm.proxy.$service.fetch({
    //   url: '/api/bsc/user/index',
    //   params: {
    //     userId: 'CC1725'
    //   }
    // })
    let taskStatusEumLists = {
      1: '待分配',
      2: '已分配',
      3: '进行中',
      4: '已完成'
    }
    let taskTypeEumLists = {
      1: '系统创建',
      2: '飞书任务',
      3: '悬赏任务',
      4: '项目任务'
    }
    let pickTypeLists = {
      1: '悬赏',
      2: '指派'
    }
    let data = reactive({
      // 员工职位信息
      'employJobInfo': {
        'employId': 'CC1725',
        'jobCode': 'T4-3',
        'jobName': '高级架构师',
        'jobType': 'xxx',
        'jobDuty': 'xxxxx',
        'employEmail': 'xxx@coocaa.com',
        'percentage': '30%', // 公司达到此级别人数占比
        'nextJobCode': 'T4-4',
        'nextJobName': '资深架构师'
      },
      // 本月积分
      'monthScore': {
        'thisMonthScore': '2000.00', // 本月积分
        'monthRatio': '15%', // 月环比 = （本月积分-上月积分）/上月积分
        'accumulateScore': '5000.00', // 累计积分
        'monthScorePercent': '30%' // 大于等于本月所得积分的人数占比
      },
      // 积分墙
      'completedTask': [
        {
          'taskScore': '100.00', // 任务积分
          'pickType': 2, // 务领取类型，1个人领取，2指派领取
          'taskStatus': 1, // 任务状态, 1待分配，2已分配，3进行中，4已完成
          'taskType': 2, // 任务类型，1系统创建，2飞书任务，3悬赏任务，4项目任务
          'taskName': '测试', // 任务名称
          'createTime': '2022-xxx-xxx', // 创建时间
          'employId': 'CC12345', // 员工ID
          'employName': '张伟' // 员工名称
        }
      ],
      // 最近任务
      'latestTaskList': [
        {
          'taskScore': '100.00',
          'pickType': 2,
          'taskStatus': 1,
          'taskType': 2,
          'taskName': '测试',
          'createTime': '2022-xxx-xxx',
          'employId': 'CC12345',
          'employName': '张伟'
        }
      ]
    })
    let userId = inject('userId')
    onMounted(() => {
      getPageInfo()
    })
    let employJobInfo = ref({})
    let monthScore = ref({})
    let completedTask = ref([])
    let latestTaskList = ref([])
    function getPageInfo () {
      vm.proxy.$service.fetch({
        url: '/api/bsc/user/index',
        params: {
          userId: userId// 'CC1621'
        }
      }).then(res => {
        console.log(res)
        employJobInfo.value = { ...res.employJobInfo }
        monthScore.value = { ...res.monthScore }
        completedTask.value = [...res.completedTask]
        latestTaskList.value = [...res.latestTaskList]
      })
    }

    /// 
    let statusType = function (type) {
      console.log(type)
      switch (type) {
        case 1:
          return 'info'
        case 2:
          return 'warning'
        case 3:
          return 'error'
      }
    }
    return {
      employJobInfo,
      monthScore,
      completedTask,
      latestTaskList,
      /// /
      taskStatusEumLists,
      taskTypeEumLists,
      pickTypeLists,
      ///
      statusType
    }
  },

  components: {

  }
}
</script>

<style scoped lang="stylus">
.top
  display flex
  justify-content space-between
  margin-bottom 25px
  .top-item
    padding 10px
    overflow hidden
    border-radius: 4px;
    width 33%
    border: 1px solid #ebeef5;
    background-color: #fff;
    color: #303133;
    transition: .3s;
    box-shadow: 0 2px 12px 0 rgba(0 0 0 , 20%);
  .top-item+.top-item
    margin-left: 10px
  .top-item:last-of-type
    margin-right: auto
  .title
    margin-bottom 30px
.top-item
  .name
    margin-bottom: 20px
    .big
      font-size:32px
  .name-bot-wrapper
    display flex
    margin-bottom: 20px
    font-size: 14px
    justify-content: space-between
    .count
      color rgb(56,104,255)
  .bot
    font-size: 14px
    border-top: 1px solid #999999dd
    padding-top: 10px
    .lv-percent
      color rgb(56,104,255)

.bot-container
  display flex
.count-wall
  box-shadow: 0 2px 12px 0 rgba(0 0 0 , 20%);
  padding 10px
  overflow hidden
  border-radius: 4px;
  flex 1 3
  .title
    margin-bottom: 25px
    display: flex
    align-items: center
  .count-wall-lists
    max-height: 230px
    overflow-y: auto
    .tag-wra
      .el-tag+.el-tag
        margin-left: 10px
    .item
      display flex
      align-items center
      .name,.user-name
        font-size: 14px
      .name
        margin-left: 15px
        width 300px
        white-space nowrap
        text-overflow: ellipsis
        overflow hidden
      .time-data
        font-size: 12px
        margin-left: auto
.task-wrap
  box-shadow: 0 2px 12px 0 rgba(0 0 0 , 20%);
  padding 10px
  margin-left: 20px
  overflow hidden
  border-radius: 4px;
  flex 1 1
  .task-top
    display flex
    align-items center
    margin-bottom: 25px;
    .more
      font-size: 14px
      color: #999
      margin-left: auto
  .task-list
    .tag-wra
      .el-tag+.el-tag
        margin-left: 10px
    .item
      display flex
      align-items center
      .name,.user-name
        font-size: 14px
      .name
        margin-left: 15px
        white-space nowrap
        text-overflow: ellipsis
        overflow hidden
        flex 1 0
      .time-data
        font-size: 12px
        margin-left: auto

.jf-rule
  font-size: 12px
  margin-left: 15px
  display inline-block
  color blue
  cursor pointer
  margin-left auto
</style>
